import {
    SET_RECENT_DEPLOYMENT_PACKAGES,
    SET_SCHEDULED_DEPLOYMENT_PACKAGES,
    SET_SAVED_DEPLOYMENT_PACKAGES,
    SET_DEPLOYMENT_PACKAGES_DETAILS,
    SET_RESET_DEPLOYMENT_LIST,
    SET_RECENT_PACKAGES_LOADING,
    SET_SAVED_PACKAGES_LOADING,
    SET_SCHEDULED_PACKAGES_LOADING,
    SET_PACKAGE_DETAILS_LOADING,
    SET_RESET_SAVED_DEPLOYMENT_PACKAGES
} from './actions';

export const initialState = {
    recentDeploymentPackages: {
        result: [],
        nextToken: ""
    },
    savedDeploymentPackages: {
        result: [],
        nextToken: ""
    },
    scheduledDeploymentPackages: {
        result: [],
        nextToken: ""
    },
    packageDetails: {},
    loadingRecentPackages: false,
    loadingScheduledPackages: false,
    loadingSavedPackages: false,
    loadingPackageDetails: false
}

export const deployment = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_RECENT_DEPLOYMENT_PACKAGES:
            let recentDeploymentPackages_: any = state.recentDeploymentPackages;
            recentDeploymentPackages_.result = [...recentDeploymentPackages_.result, ...action.payload.result];
            recentDeploymentPackages_.nextToken = action.payload.nextToken;
            return { ...state, recentDeploymentPackages: recentDeploymentPackages_ || {}, loadingRecentPackages: false };
        case SET_SCHEDULED_DEPLOYMENT_PACKAGES:
            let scheduledDeploymentPackages_: any = state.scheduledDeploymentPackages;
            scheduledDeploymentPackages_.result = [...scheduledDeploymentPackages_.result, ...action.payload.result];
            scheduledDeploymentPackages_.nextToken = action.payload.nextToken;
            return { ...state, scheduledDeploymentPackages: scheduledDeploymentPackages_ || {}, loadingScheduledPackages: false };
        case SET_SAVED_DEPLOYMENT_PACKAGES:
            let savedDeploymentPackages_: any = state.savedDeploymentPackages;
            savedDeploymentPackages_.result = [...savedDeploymentPackages_.result, ...action.payload.result];
            savedDeploymentPackages_.nextToken = action.payload.nextToken;
            return { ...state, savedDeploymentPackages: savedDeploymentPackages_ || {}, loadingSavedPackages: false };
        case SET_DEPLOYMENT_PACKAGES_DETAILS:
            return { ...state, packageDetails: action.payload || {}, loadingPackageDetails: false };
        case SET_RESET_DEPLOYMENT_LIST:
            return {
                ...state,
                recentDeploymentPackages: {
                    result: [],
                    nextToken: ""
                },
                scheduledDeploymentPackages: {
                    result: [],
                    nextToken: ""
                },
                savedDeploymentPackages: {
                    result: [],
                    nextToken: ""
                }
            };
        case SET_RECENT_PACKAGES_LOADING:
            return {
                ...state,
                loadingRecentPackages: action.payload,
                loadingScheduledPackages:false,
                loadingSavedPackages: false,
                loadingPackageDetails: false
            };
        case SET_SCHEDULED_PACKAGES_LOADING:
            return {
                ...state,
                loadingScheduledPackages: action.payload,
                loadingRecentPackages: false,
                loadingSavedPackages: false,
                loadingPackageDetails: false
            };
        case SET_SAVED_PACKAGES_LOADING:
            return {
                ...state,
                loadingSavedPackages: action.payload,
                loadingScheduledPackages:false,
                loadingRecentPackages: false,
                loadingPackageDetails: false
            };
        case SET_PACKAGE_DETAILS_LOADING:
            return {
                ...state,
                loadingPackageDetails: action.payload,
                loadingSavedPackages: false,
                loadingRecentPackages: false,
                loadingScheduledPackages:false
            };
        case SET_RESET_SAVED_DEPLOYMENT_PACKAGES:
            return {
                ...state,
                savedDeploymentPackages: {
                    result: [],
                    nextToken: ''
                }
            };
        default:
            return state;
    }
}